/* eslint-disable */

import axios from "axios";
import axiosInstance from "../../../axiosInstance";

export const fetchBanners = (token) => {
  return axios.get(`${process.env.REACT_APP_BASE_URL}/admin/bottom-banners`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateBannersPositions = (token, positions) => {
  return axiosInstance.post(
    "/admin/bottom-banners/positions",
    { positions },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const deleteBannerById = (token, id) => {
  return axios.delete(
    `${process.env.REACT_APP_BASE_URL}/admin/bottom-banners/${id}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const createBanner = (token, data) => {
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/admin/bottom-banners`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const updateBanner = (token, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_BASE_URL}/admin/bottom-banners/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
